import { useActiveEnv } from '@hooks/use-active-env';
import readCookie from '@utils/read-cookie';
import readSubcookie from '@utils/read-subcookie';
import * as React from 'react';
import { Helmet } from 'react-helmet';

const OneTrust = () => {
  let dds = 'd8606fe0-eb46-49e2-9118-e39304fc0f7b';
  if (useActiveEnv() !== 'production') {
    dds += '-test';
  }

  const consentCookiePresent = readCookie('OptanonConsent');
  let preferenceVals = null;
  if (consentCookiePresent) {
    const groups = readSubcookie(consentCookiePresent, 'groups');
    if (groups) {
      preferenceVals = groups.replaceAll(':1', '');
    }
  }

  const cookieProScript = (
    <Helmet>
      <script type="text/javascript">{`
        (function() {
          const readCookie = ${readCookie};
          const optanonCookie = readCookie('OptanonConsent');
          if (!optanonCookie) {
            var s = document.createElement('script');
              s.type = 'text/javascript';
              s.async = true;
              s.charset = "UTF-8";
              s.setAttribute('data-document-language','true');
              s.setAttribute('data-domain-script','${dds}');
              s.src = '//cdn.cookielaw.org/scripttemplates/otSDKStub.js';

              document.getElementsByTagName('head')[0].appendChild(s);
          }
        })();
      `}</script>
      <script type="text/javascript">{`
        function OptanonWrapper() { }
      `}</script>
    </Helmet>
  );

  const pushOnetrustDataLayer = (
    <Helmet>
      <script type="text/javascript">{`
        if(!dataLayer){ var dataLayer=[]; }
        dataLayer.push({
          'event': 'OneTrustLoaded',
          'OnetrustActiveGroups': '${preferenceVals}'
        },{
          'event': 'OptanonLoaded',
          'OptanonActiveGroups': '${preferenceVals}'
        },{
          'event': 'OneTrustGroupsUpdated',
          'OnetrustActiveGroups': '${preferenceVals}'
        });
      `}</script>
    </Helmet>
  );

  if (preferenceVals) {
    return pushOnetrustDataLayer;
  } else {
    return cookieProScript;
  }
};

export default OneTrust;
